import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface MonthNavigationProps {
  currentMonth: Date
  onPreviousMonth: () => void
  onNextMonth: () => void
  onMonthChange: (monthIndex: string) => void
  onYearChange: (year: string) => void
  isMonthSelectorOpen: boolean
  setIsMonthSelectorOpen: (open: boolean) => void
}

export const MonthNavigation = ({
  currentMonth,
  onPreviousMonth,
  onNextMonth,
  onMonthChange,
  onYearChange,
  isMonthSelectorOpen,
  setIsMonthSelectorOpen,
}: MonthNavigationProps) => {
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={onPreviousMonth}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Popover open={isMonthSelectorOpen} onOpenChange={setIsMonthSelectorOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" className="font-medium">
            {format(currentMonth, 'MMMM yyyy', { locale: de })}
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-80" align="start">
          <div className="grid gap-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm font-medium">Monat</label>
                <Select value={currentMonth.getMonth().toString()} onValueChange={onMonthChange}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0">Januar</SelectItem>
                    <SelectItem value="1">Februar</SelectItem>
                    <SelectItem value="2">März</SelectItem>
                    <SelectItem value="3">April</SelectItem>
                    <SelectItem value="4">Mai</SelectItem>
                    <SelectItem value="5">Juni</SelectItem>
                    <SelectItem value="6">Juli</SelectItem>
                    <SelectItem value="7">August</SelectItem>
                    <SelectItem value="8">September</SelectItem>
                    <SelectItem value="9">Oktober</SelectItem>
                    <SelectItem value="10">November</SelectItem>
                    <SelectItem value="11">Dezember</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium">Jahr</label>
                <Select value={currentMonth.getFullYear().toString()} onValueChange={onYearChange}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {Array.from({ length: 10 }, (_, i) => {
                      const year = new Date().getFullYear() - 5 + i
                      return (
                        <SelectItem key={year} value={year.toString()}>
                          {year}
                        </SelectItem>
                      )
                    })}
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </PopoverContent>
      </Popover>
      <Button variant="outline" size="sm" onClick={onNextMonth}>
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
